module.exports = __webpack_public_path__ + "img/2.d90f26c6.png";